import { Download, X } from "lucide-react";
import { todayISO } from "@/lib/format";

const shift = (days) => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

const PRESETS = [
  { id: "all", l: "All", get: () => ["", ""] },
  { id: "7d", l: "7 days", get: () => [shift(6), todayISO()] },
  { id: "month", l: "This month", get: () => [todayISO().slice(0, 8) + "01", todayISO()] },
];

const DateIn = ({ label, value, onChange, testId }) => (
  <label className="flex items-center gap-2 h-10 px-3 bg-white border border-slate-300 focus-within:border-slate-900">
    <span className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500">{label}</span>
    <input type="date" data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)}
      className="bg-transparent outline-none font-mono text-sm w-[130px]" />
  </label>
);

export const FilterBar = ({ start, end, setRange, onExport, exporting, canExport }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="date-range-filter">
    <div className="flex border border-slate-300 bg-white">
      {PRESETS.map((p) => (
        <button key={p.id} data-testid={`filter-preset-${p.id}`} onClick={() => setRange(...p.get())}
          className="h-10 px-3 text-xs font-semibold border-r border-slate-200 last:border-r-0 hover:bg-slate-900 hover:text-white transition-colors">
          {p.l}
        </button>
      ))}
    </div>
    <DateIn label="From" value={start} onChange={(v) => setRange(v, end)} testId="filter-start-date" />
    <DateIn label="To" value={end} onChange={(v) => setRange(start, v)} testId="filter-end-date" />
    {(start || end) && (
      <button data-testid="filter-clear-btn" onClick={() => setRange("", "")} className="h-10 w-10 grid place-items-center border border-slate-300 bg-white hover:bg-slate-100" title="Clear">
        <X size={14} />
      </button>
    )}
    {canExport && <button data-testid="excel-export-btn" onClick={onExport} disabled={exporting}
      className="h-10 px-4 ml-auto flex items-center gap-2 text-sm font-semibold bg-emerald-700 text-white hover:bg-emerald-800 transition-colors disabled:opacity-60">
      <Download size={15} /> {exporting ? "Exporting…" : "Excel"}
    </button>}
  </div>
);
